import React from "react";
import PageTitle from "../../Shared/PageTitle/PageTitle";
import Category from "./components/Category";

import "./Equipement.css";

const Equipement = () => {
  return (
    <>
      <PageTitle title={"Equipement"} currentPage={"Equipement"} />
      <Category />
    </>
  );
};

export default Equipement;
